import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {DmDocumentDto} from "./dm-document.dto";
import {DmDocumentAssignmentTypeEnum} from "../../../enum/dm-document-assignment-type-enum.enum";
import {ObjectTypeDto} from "../../../../../core/cc/model/dto/entity/object-type.dto";

export class DmDocumentAssignmentEuDto extends DtoDetail{


    public documentDto? : DmDocumentDto;
    public documentDtoId : number;
    public documentDtoName : string;
    public documentAssignmentType: DmDocumentAssignmentTypeEnum;
    public objectTypeDto? : ObjectTypeDto;
    public objectTypeDtoId : number;
    public objectTypeDtoName : string;
    public objectId: number;

}